<!-- Copyright (c) 2024 Digital Systems (M) Sdn. Bhd. -->

<template>
  <div class="exchange-rate-main">
    <div>
      <Menus :menu="menu" :menuWidth="215" @menuClicked="menuClicked" />
    </div>

    <div class="table-box-container">
      <TableBox :tableData="exchangeRateTableData" :selectedRow.sync="exchangeRateSelectedRow" title="Exchange Rate" :dataType="columnTypeMain" />
    </div>

    <PopupEntry :show.sync="popupEntryShow" v-if="popupEntryShow" :title="popupEntryTitle" :updatedBy="updatedBy"
      :createdBy="createdBy" @save="popupEntrySaveClicked" :requiredError="popupEntryRequiredError" :successMessages="popupEntrySuccessMessages"
      :messages="popupEntryMessages" :errorMessages="popupEntryErrorMessages" @requiredClicked="popupeEntryRequiredClicked" :viewMode="viewMode"
      :cancelButton="viewMode ? 'Close' : 'Cancel'">
      <div class="general-details" style="display: flex; height: 100;">
        <!-- General Details -->
        <div class="general-inputs" placeholder="Container">
          <!-- ExchangeRateCode -->
          <Input :isDisabled="viewModePK" placeholder="Currency Code (max. 3 characters)" :isRequired="true"
            :inputValue.sync="currencyCode" :errorMessage.sync="currencyCodeError" ref="category_currencyCode" 
            @focusChanged="currencyCodeInputFocusChanged"/>
          <!-- ExchangeRateDescription -->
          <Input :isDisabled="viewMode" placeholder="Description (max. 30 characters)" :isRequired="true"
            :inputValue.sync="description" :maxLength="30" :text.sync="description" :errorMessage.sync="descriptionError" ref="category_description" />          
        </div> 
      </div>

      <!-- Exchange Rate List -->
      <div class="exchange-rate-list">
        <div class="exchange-rate-history">
          <div v-if="!viewMode" class="call-to-action-buttons">
            <button @click="addExchangeRateButtonClicked" :disabled="showExchangeRateInputs">Add</button>
            <button @click="deleteExchangeRateButtonClicked" :disabled="showExchangeRateInputs">Delete</button>
          </div>

          <div class="table-box-container">
            <TableBox v-if="showExchangeRateHistoryTableBox" title="Exchange Rate History" :tableData="exchangeRateHistoryWithoutDeleted" 
              :dataType="columnTypeMain" :hideColumns="exchangeRateHistoryTableBoxHideColumns" :selectedRow.sync="exchangeRateHistorySelectedRow" 
              :additionalButtons="viewMode ? [] : exchangeRateHistoryTableBoxAdditionalButtons" @buttonClicked="editExchangeRateButtonClicked"/>
          </div>
        </div>

        <div v-if="showExchangeRateInputs" class="exchange-rate-inputs">
          <div class="call-to-action-buttons">
            <button v-if="exchangeRateBeingEdited === null" @click="addExchangeRateInputButtonClicked">Add</button>
            <button v-else @click="editExchangeRateInputButtonClicked">Edit</button>
            <button @click="cancelExchangeRateInputButtonClicked">Cancel</button>
          </div>
          <div>
          <!-- Exchange Rate -->
          <Input :isDisabled="viewMode" placeholder="Exchange Rate" :isRequired="true"
            :inputValue.sync="exchangeRate" validator="positiveDecimal,14" :errorMessage.sync="exchangeRateError" ref="category_exchangeRate" />  
            <!-- Factor -->
          <Input :isDisabled="viewMode" placeholder="Factor" :isRequired="true"
            :inputValue.sync="factor" validator="positiveInteger,9" :errorMessage.sync="factorError" ref="category_factor"/>
          <!-- Exchange Date -->
          <DateTimePicker :isDisabled="viewMode" placeholder="Exchange Date" :value.sync="exchangeDate" :showTime="false" 
            :isRequired="true" :errorMessage.sync="exchangeDateError" ref="exchange_date"/>
          </div>
        </div>
      </div>
    </PopupEntry>
  </div>
</template>
<script>

export default {
  components: {
  },
  computed: {
    exchangeRateHistoryWithoutDeleted: function() {
      // return exchange ratess that are not deleted
      return this.exchangeRateHistoryTableData.filter((exchangeRateData) => exchangeRateData._action !== "D");
    },
  },
  data: function () {
    return {
      //side menu list
      menu: [
        { title: 'New Exchange Rate', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-add-new-50.png', key: 'MnuNew', visible: true, enabled: true },
        { title: 'Edit Exchange Rate', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-edit-64%20(1).png', key: 'MnuEdit', visible: true, enabled: true },
        { title: 'Delete Exchange Rate', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-reduce-50.png', key: 'MnuDelete', visible: true, enabled: true },
        { title: 'View Exchange Rate', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-view-64.png', key: 'MnuQuery', visible: true, enabled: true },
      ],

      //table
      exchangeRateTableData: [],

      // Exchange Rate History
      showExchangeRateHistoryTableBox: true, // used to force a re-execution of TableBox's mounted, in order to update _rowid
      exchangeRateHistoryTableData: [],
      exchangeRateHistorySelectedRow: [],
      exchangeRateHistoryTableBoxHideColumns: ["ID", "Currency Code", "_action"],
      exchangeRateHistoryTableBoxAdditionalButtons: [{ text: 'Edit', index: 0, width: 75 }],

      exchangeRateBeingEdited: null, // stores the exchange rate the user is currently editting, used to update the row that was edited once user confirms inputs
      // compare with ID if available, if not then with _rowid
      showExchangeRateInputs: false,

      //popup entry
      popupEntryShow: false,
      popupEntryTitle: '',
      createdBy: '',
      updatedBy: '',
      viewMode: false,
      viewModePK: false,
      popupEntryRequiredError: [],
      popupEntrySuccessMessages: [],
      popupEntryMessages: [],
      popupEntryErrorMessages: [],
      exchangeRateSelectedRow: [],

      //fields
      currencyCode: '', 
      description: '', 
      exchangeRate: '',
      factor: '1',
      exchangeDate: null,

      //error message
      currencyCodeError: '',
      descriptionError: '',
      exchangeRateError: '',
      factorError: '',
      exchangeDateError: '',

      //dropdown
      columnTypeMain: {
        "Year": "number",
        "Currency Rate": "number",
        "Exchange Date": "date",
        "Factor": "number",
        "ID": "number"
      },
      
    };
  },
  props: {
  },
  methods: {
    getExchangeRateList: async function () {
      this.exchangeRateTableData = [];
      this.$fullscreenLoading('Getting Exchange Rate');
      this.exchangeRateTableData = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'CURRENCY', module: 'MASTER'});
      this.$fullscreenLoading();
      },

    currencyCodeInputFocusChanged: async function(focus) {
      if (!focus) {
        let currencyCodeExists = false;

        this.exchangeRateTableData.forEach(c => {
          if(c['Currency Code'] == this.currencyCode.toUpperCase()){
            currencyCodeExists = true;
          }
        });
        if(currencyCodeExists == true){
          const alert = await this.$showAlert('warning', 'Currency Code Already Exists', 'Please go to "Edit Exchange Rate" to make changes', [
            { text: 'Edit' },
            { text: 'Cancel', color: 'lightgrey' },
          ]);
          if(alert == 'Edit'){
            this.populateViewDetails(this.currencyCode.toUpperCase());
            this.viewMode = false;
            this.viewModePK = true;
            this.popupEntryShow = true;
            this.popupEntryTitle = 'Edit Exchange Rate';
          } else {
            this.$refs.category_currencyCode.setFocus();
            this.viewModePK = false;
          }
        }
      }
    },

    menuClicked: async function (e) {
      this.clearPopupEntryMessages();
      this.clearAllFields();

      switch (e.title) {
        case 'New Exchange Rate':
          this.viewMode = false;
          this.viewModePK = false;
          this.popupEntryShow = true;
          this.action = 'N';
          this.popupEntryTitle = 'New Exchange Rate';
          this.exchangeDate = new Date();
          break;
        case 'Edit Exchange Rate':
          if (this.exchangeRateSelectedRow.length == 0) {
            this.$showAlert('error', 'No exchange rate is selected', 'Please select a exchange rate to edit');
          } else {
            await this.populateViewDetails(this.exchangeRateSelectedRow[0]['Currency Code']);
            this.viewMode = false;
            this.viewModePK = true;
            this.popupEntryShow = true;
            this.popupEntryTitle = 'Edit Exchange Rate';
          }
          break;

        case 'Delete Exchange Rate':
          if (this.exchangeRateSelectedRow.length == 0) {
            this.$showAlert('error', 'No exchange rate is selected', 'Please select a exchange rate to delete');
            break;
          }
          await this.populateViewDetails(this.exchangeRateSelectedRow[0]['Currency Code'])

          let deleteMessage = `Are you sure you want to delete Exchange Rate <b>${this.exchangeRateSelectedRow[0]['Currency Code']}</b>?`;
          let additionalDeletions = [];
          if (this.exchangeRateHistoryTableData.length > 0) {
            additionalDeletions.push(`<b>${this.exchangeRateHistoryTableData.length} Exchange Rate${this.exchangeRateHistoryTableData.length > 1 ? "s" : ""}<b>`);
          }
          if (additionalDeletions.length > 0) {
            deleteMessage += `<br><br>This will also delete: ${additionalDeletions.join(" and ")}`;
          }

          const deleteConfirmation = await this.$showAlert('warning', 'Delete Exchange Rate', deleteMessage, [
            { text: 'Delete', textColor: 'white', color: 'red' },
            { text: 'Cancel', textColor: 'black', color: 'lightgray' },
          ]);
          if (deleteConfirmation === 'Cancel') {
            break;
          }

          this.$fullscreenLoading("Deleting Exchange Rate");
          const result = await this.$apiCallV2('/ExchangeRate/SaveExchgRate', this.formatSaveExchangeRateRequestBody("D"));
          this.$fullscreenLoading();

          if (result[0]['Results'] == 0) { // Delete successful
            this.$showAlert('success', 'Exchange Rate Deleted', `Successfully deleted Exchange Rate for ${this.exchangeRateSelectedRow[0]['Currency Code']}`);
            this.exchangeRateSelectedRow = [];
            this.getExchangeRateList();
  
          } else { // Delete error
            this.$showAlert('error', 'Exchange Rate Not Deleted', `There was an error deleting Exchange Rate for ${this.exchangeRateSelectedRow[0]['Currency Code']}`);
          }
          break;

        case 'View Exchange Rate':
          if (this.exchangeRateSelectedRow.length == 0) {
            this.$showAlert('error', 'No exchange rate is selected', 'Please select a exchange rate to view');
          } else {
            await this.populateViewDetails(this.exchangeRateSelectedRow[0]['Currency Code']);
            this.popupEntryTitle = 'View Exchange Rate';
            this.viewMode = true;
            this.viewModePK = true;
            this.popupEntryShow = true;   
          }
          break;
      }
    },

    clearAllFields: function () {
      this.currencyCode = null;
      this.currencyCodeError = '';
      this.description = '';
      this.descriptionError = '';
      this.exchangeRate= '';
      this.exchangeRateError = '';
      this.factor= '';
      this.factorError = '';
      this.createdBy = '';
      this.updatedBy = '';
      this.exchangeDate = null;
      this.exchangeDateError = '';
      this.exchangeRateHistoryTableData = [];
      this.showExchangeRateInputs = false;
    },

    addExchangeRateButtonClicked: function(pointerEvent) {
      this.clearExchangeRateInputs();
      this.showExchangeRateInputs = true;
      this.factor = '1';
      this.exchangeDate = new Date();
      this.exchangeRateBeingEdited = null;
    },
    editExchangeRateButtonClicked: function(buttonText, rowClicked) {
      this.exchangeRateBeingEdited = {
        ...rowClicked,
      };
      this.clearExchangeRateInputs();
      this.populateExchangeRateInputs(rowClicked);
      this.showExchangeRateInputs = true;
    },
    deleteExchangeRateButtonClicked: async function(pointerEvent) {
      if (this.exchangeRateHistorySelectedRow.length === 0) {
        this.$showAlert("error", "No Exchange Rate Selected", "Please select a exchange rate to delete", [{"text": "OK"}]);
        return;
      }

      const deleteConfirmation = await this.$showAlert(
        "warning",
        "Delete Exchange Rate",
        "Are you sure you wish to delete the selected exchange rate?",
        [{"text": "Delete", "color": "Red", "textColor": "white"}, {"text": "Cancel"}]
      );
      if (deleteConfirmation === "Cancel") {
        return;
      }

      const exchangeRateToDelete = this.exchangeRateHistorySelectedRow[0];
      let matchedIndex; // find the row being deleted in the tablebox data
      if (exchangeRateToDelete.ID !== undefined && exchangeRateToDelete.ID !== null) { // if ID exists, strict comparison with undefined and null because ID might be 0
        const foundIndex = this.exchangeRateHistoryTableData.findIndex((exchangeRateData) => exchangeRateData.ID === exchangeRateToDelete.ID);
        if (foundIndex !== -1) { // if a match was found with ID
          matchedIndex = foundIndex; // assign the matching index
        }
      }
      if (matchedIndex === undefined && exchangeRateToDelete._rowid) { // if ID does not exist or could not find a match with ID, and _rowid exists
        const foundIndex = this.exchangeRateHistoryTableData.findIndex((exchangeRateData) => exchangeRateData._rowid === exchangeRateToDelete._rowid); // try matching with _rowid instead
        if (foundIndex !== -1) { // if a match was found with _rowid
          matchedIndex = foundIndex; // assign the matching index
        }
      }
      if (matchedIndex === undefined) { // if a match still can't be found, which shouldn't happen
        console.error("ExchangeRate - Could not find the row being deleted");
        return;
      }

      this.exchangeRateHistoryTableData.forEach((item) => {
        if (item["#"] > this.exchangeRateHistoryTableData[matchedIndex]["#"]) {
          item["#"] = (parseInt(item["#"]) - 1).toString();
        }
      });

      if (exchangeRateToDelete._action === "N") { // if deleting a newly added exchange rate, simply remove the element from the array
        this.exchangeRateHistoryTableData.splice(matchedIndex, 1);
      } else { // if deleting an existing exchange rate, set the _action to "D" and POST to API
        this.exchangeRateHistoryTableData[matchedIndex]._action = "D";
      }

      const modifiedExchangeRateHistoryTableData = this.exchangeRateHistoryTableData.map((exchangeRateData) => {
        delete exchangeRateData._rowid;
        return exchangeRateData;
      });
      this.showExchangeRateHistoryTableBox = false; // hide TableBox and re-render on nextTick
      this.exchangeRateHistoryTableData = [];
      this.exchangeRateHistorySelectedRow = [];
      this.$nextTick(() => {
        this.exchangeRateHistoryTableData = modifiedExchangeRateHistoryTableData;
        this.showExchangeRateHistoryTableBox = true; // re-render to force a re-execution of mounted in TableBox, in order to update _rowid
      });
    },

    clearExchangeRateInputs: function() {
      this.exchangeRate= '';
      this.exchangeRateError = '';
      this.factor= '';
      this.factorError = '';
      this.exchangeDate = null;
      this.exchangeDateError = '';
    },
    
    populateExchangeRateInputs: async function(ExchangeRatedetails) {
      this.exchangeRate = this.populateTextTrim(ExchangeRatedetails['Currency Rate']);
      this.factor = this.populateTextTrim(ExchangeRatedetails['Factor']);
      this.exchangeDate = ExchangeRatedetails['Exchange Date'] ? new Date(ExchangeRatedetails['Exchange Date']) : null;
    },

    addExchangeRateInputButtonClicked: function(pointerEvent) {
      const isInvalid = this.checkExchangeRateFields();
      if (isInvalid) {
        return;
      }

      const modifiedExchangeRateHistoryTableData = [
        ...this.exchangeRateHistoryTableData.map((exchangeRateData) => {
          delete exchangeRateData._rowid;
          return exchangeRateData;
        }),
        {
          // populate "ExchangeRate" later when actually saving instead, use input value from common field
          // this way, won't have to prevent the user from entering exchange rate first before creating a new exchange rate   
          "#": (this.exchangeRateHistoryWithoutDeleted.length + 1).toString(),
          "Year": new Date(this.exchangeDate).getFullYear(),
          "Exchange Date": new Date(this.exchangeDate).formatString("yyyy-MM-dd"),
          "Currency Rate": this.exchangeRate,
          "Factor": this.factor,

          _action: "N"
        }
        
      ];
      this.showExchangeRateHistoryTableBox = false; // hide TableBox and re-render on nextTick
      this.exchangeRateHistoryTableData = [];
      this.exchangeRateHistorySelectedRow = [];
      this.showExchangeRateInputs = false;
      this.$nextTick(() => {
        this.exchangeRateHistoryTableData = modifiedExchangeRateHistoryTableData;
        this.showExchangeRateHistoryTableBox = true; // re-render to force a re-execution of mounted in TableBox, in order to update _rowid
      });
    },
    editExchangeRateInputButtonClicked: function(pointerEvent) {
      const isInvalid = this.checkExchangeRateFields();
      if (isInvalid) {
        return;
      }

      let matchedIndex; // find the row being edited in the tablebox data
      if (this.exchangeRateBeingEdited.ID !== undefined && this.exchangeRateBeingEdited.ID !== null) { // if ID exists, strict comparison with undefined and null because ID might be 0
        const foundIndex = this.exchangeRateHistoryTableData.findIndex((exchangeRateData) => exchangeRateData.ID === this.exchangeRateBeingEdited.ID);
        if (foundIndex !== -1) { // if a match was found with ID
          matchedIndex = foundIndex; // assign the matching index
        }
      }
      if (matchedIndex === undefined && this.exchangeRateBeingEdited._rowid) { // if ID does not exist or could not find a match with ID, and _rowid exists
        const foundIndex = this.exchangeRateHistoryTableData.findIndex((exchangeRateData) => exchangeRateData._rowid === this.exchangeRateBeingEdited._rowid); // try matching with _rowid instead
        if (foundIndex !== -1) { // if a match was found with _rowid
          matchedIndex = foundIndex; // assign the matching index
        }
      }
      if (matchedIndex === undefined) { // if a match still can't be found, which shouldn't happen
        console.error("ExchangeRate - Could not find the row being edited");
        return;
      }

      this.exchangeRateHistoryTableData.splice(matchedIndex, 1, {
        // populate "Exchange Rate" later when actually saving instead, use input value from common field
        // this way, won't have to prevent the user from entering exchange rate first before creating a new exchange rate
        "#": this.exchangeRateBeingEdited["#"],
        "Year": new Date(this.exchangeDate).getFullYear(),
        "Exchange Date": new Date(this.exchangeDate).formatString("yyyy-MM-dd"),
        "Currency Rate": this.exchangeRate,
        "Factor": this.factor,
        "ID": this.exchangeRateBeingEdited.ID,
       
        _action: this.exchangeRateBeingEdited._action === "N" ? "N" : "E", // if editing a new exchange rate, leave as new, else set as edit
      });

      const modifiedExchangeRateHistoryTableData = this.exchangeRateHistoryTableData.map((exchangeRateData) => {
        delete exchangeRateData._rowid;
        return exchangeRateData;
      });
      this.showExchangeRateHistoryTableBox = false; // hide TableBox and re-render on nextTick
      this.exchangeRateHistoryTableData = [];
      this.exchangeRateHistorySelectedRow = [];
      this.showExchangeRateInputs = false;
      this.$nextTick(() => {
        this.exchangeRateHistoryTableData = modifiedExchangeRateHistoryTableData;
        this.showExchangeRateHistoryTableBox = true; // re-render to force a re-execution of mounted in TableBox, in order to update _rowid
      });
    },
    cancelExchangeRateInputButtonClicked: function(pointerEvent) {
      this.exchangeRateBeingEdited = null;
      this.showExchangeRateInputs = false;
    },

    checkExchangeRateFields: function () {
      // this.clearExchangeRateInputs ();
      let error = false;

      if (!this.exchangeRate) {
        this.exchangeRateError = 'Exchange Rate is required!';
        error = true;
      }
      else {
        let split = this.exchangeRate.split('.');
        if (split[0].length > 15) {
          // display error
          this.exchangeRateError = 'Exchange Rate cannot exceed 15 digits!';
          error = true;
        } else if (split[1] && split[1].length > 4) {
          // display error for decimal
          this.exchangeRateError = 'Exchange Rate cannot have more than 4 decimal points!';
          error = true;
        }
      }
      
      if (!this.factor) {
        this.factorError = 'Factor is required!';
        error = true;
      } 
      else {
        if (this.factor.length > 9) {
          this.factorError = 'Factor cannot exceed 9 digits!';
          error = true;
        }
      }

      if (!this.exchangeDate) {
        this.exchangeDateError = 'Exchange date is required!';
        error = true;
      }
      return error;
    },

    promptDiscardExchangeRateChanges: function() {
      // $showAlert returns a promise, which can be awaited in the calling function to get the button clicked by the user
      return this.$showAlert(
        "warning",
        "Discard Changes",
        "You have unsaved exchange rate changes.<br>Do you wish to discard the changes?",
        [{"text": "Discard", "color": "Red", "textColor": "white"}, {"text": "Cancel"}]
      );
    },

    checkPopupEntryFields: function () {
      let error = false;

      this.clearPopupEntryMessages();
      if (!this.currencyCode || this.currencyCode.trim() === '' ) {
        this.currencyCodeError = 'Currency Code is required!';
        this.popupEntryRequiredError.push({ key: 'category_currencyCode', value: 'Currency Code is required!' });
        error = true;
      } else if (this.currencyCode.length > 3) {
        this.currencyCodeError = 'Currency Code cannot exceed 3 characters!';
        this.popupEntryRequiredError.push({ key: 'category_currencyCode', value: 'Currency Code cannot exceed 3 characters!' });
        error = true;
      } 
      if (this.description.trim() === "") {
        this.descriptionError = "Description is required!";
        this.popupEntryRequiredError.push({ key: 'descriptionError', value: "Description is required!" });
        error = true;
      } else if(this.description.length > 30) {
        this.descriptionError = "Description cannot exceed 30 characters!"
        this.popupEntryRequiredError.push({ key: 'category_description', value: "Description cannot exceed 30 characters!" });
        error = true;
      }
      return error;
    },

    clearPopupEntryMessages: function () {
      this.popupEntryRequiredError = [];
      this.popupEntrySuccessMessages = [];
      this.popupEntryMessages = [];
      this.popupEntryErrorMessages = [];
    },
    
    populateTextTrim: function (text) { // To populate text with trim
      return text ? text.trim() : '';
    },

    popupEntrySaveClicked: async function () {
      if (this.showExchangeRateInputs) {
        const discardChanges = await this.promptDiscardExchangeRateChanges();
        if (discardChanges === "Cancel") {
          return;
        }
        this.showExchangeRateInputs = false;
      }

      let error = this.checkPopupEntryFields(); // first check popup entry fields
      if (this.exchangeRateHistoryTableData.length === 0) {
        this.popupEntryErrorMessages.push('Exchange rate is required. Please fill up at least one exchange rate.');
        error = true;
      }
      if (error){
        return;
      }

      const action = this.popupEntryTitle[0]; // first character
      const requestBody = this.formatSaveExchangeRateRequestBody(action);

      this.$fullscreenLoading('Saving Exchange Rate');
      const result = await this.$apiCallV2('/ExchangeRate/SaveExchgRate', requestBody);
      this.$fullscreenLoading();

      if (result[0]['Results'] != "0") { // Save error
        this.popupEntryErrorMessages.push(`${result[0]['ErrMsg'].replace(",", "")}`);
        return;
      }
      // Save successful
      this.viewMode = true;
      this.viewModePK = true;
      this.popupEntryTitle = "View Exchange Rate";
      this.showExchangeRateHistoryTableBox = false;
      this.$nextTick(() => { // hide and re-show TableBoxes to trigger a re-execution of TableBox's mounted, so that the additional buttons get hidden
        this.showExchangeRateHistoryTableBox = true;
      });
      this.getExchangeRateList(); // refresh Exchange Rate TableBox

      if (action == 'N') {
        this.popupEntrySuccessMessages.push(`Successfully created Exchange Rate for: ${this.currencyCode}`);
      } else {
        this.popupEntrySuccessMessages.push(`Successfully edited Exchange Rate for: ${this.currencyCode}`);
      }
    },

    formatSaveExchangeRateRequestBody: function(action) {
      // formats and returns the request body for the SaveExchangeRate API endpoint
      // reads all values needed from the PopupEntry input field values
      // populate PopupEntry before calling this method
      let requestBody = {
        'action': action,  

        'ex_code': this.currencyCode.toUpperCase().trim(),
        'ex_description': this.description,
      };
      
      let exchangeRateArray = [];
      for (const exchangeRateData of this.exchangeRateHistoryTableData) {
        if (!exchangeRateData._action) {
          continue;
        }

        exchangeRateArray.push({
          "action": exchangeRateData._action,
          "ex_pos": exchangeRateData.ID ?? "", // won't have a value if it's a new exchange rate

          'ex_rate': this.exchangeRate, // populate exchange rate using common field input value, instead of using value from column
          // this way, won't have to prevent the user from entering exchange rate first before creating a new exchange rate
          'ex_factor': exchangeRateData["Factor"],
          'exdate': exchangeRateData["Exchange Date"] ? this.$dateTime.getDateTime(new Date(exchangeRateData["Exchange Date"]), 'yyyy-MM-dd') : '',
          'year': exchangeRateData["Exchange Date"] ? new Date(exchangeRateData["Exchange Date"]).getFullYear() : 'yyyy',
          'ex_customdescr': this.description,
        });
      }
      requestBody.exchangearr = exchangeRateArray;

      return requestBody;
    },

    populateViewDetails: async function (exchangeRateSelected) {
      this.$fullscreenLoading('Getting Details');
      let details = (await this.$apiCallV2('/Master/GetDetailsMaster', { "masterfile": "CURRENCY", "module": "MASTER", "recordid": exchangeRateSelected, }))["CurrDetails"]
      this.exchangeRateHistoryTableData = details['ExHistory'];
      this.currencyCode = this.populateTextTrim(details['Ex_code']);
      this.description = this.populateTextTrim(details['Ex_description']);
      this.exchangeRate = this.populateTextTrim(details['Ex_rate']);
      this.factor = this.populateTextTrim(details['Ex_factor']);
      this.exchangeDate = details['exDate'] ? new Date(details['exDate']) : null;
      //created by updated by
      this.updatedBy = `${details['UserID'].trim() ? details['UserID'].trim() : ''} ${details['Dateupdate'] ? this.$dateTime.getDateTime(new Date(details['Dateupdate']), 'dd/MM/yyyy HH:mm') : ''}`;
      this.createdBy = `${details['UserID'] || ''} ${details['Dateupdate'] ? this.$dateTime.getDateTime(new Date(details['Dateupdate']), 'dd/MM/yyyy HH:mm') : ''}`;
      this.$fullscreenLoading();
    },

    popupeEntryRequiredClicked: function (item) {
      this.$nextTick(() => {
        this.$refs[item].setFocus();
      });
    },
  },
  async mounted() {
    this.$bus.$on('pageSASControlAccess', (x) => {
      if (x.page == 'Exchange Rate') {
        x.data.forEach(k => {
          //key in menu same as control value from api
          let selectedMenu = this.menu.find(m => m['key'] == k['Control']);
          if (selectedMenu) {
            selectedMenu[k['Properties'].toLowerCase()] = (k['PropertiesValue'] == 'True');
          }
        })
      }
    });
    this.getExchangeRateList();
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.exchange-rate-main {
  font-size: 12px;
  width: 100%;
  height: 100%;
  padding: 10px 45px;
  display: flex;
  height: calc(100% - 60px);
}
.table-box-container {
  width: 100%;
  margin-left: 5px;
  padding: 5px;
  background-color: white;
  border-radius: 5px;
  display: flex;
  overflow: hidden;
}
.general-inputs {
  display: flex;
  flex-direction: column;
}
    
.exchange-rate-inputs {
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  width: 50%;
  margin-left: 3px;
}
.exchange-rate-list {
  display: flex;
  flex-direction: row;
  height: 100%;
  overflow-y: scroll;
}
.exchange-rate-history {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  margin-right: 3px;
}
.call-to-action-buttons {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-bottom: 2px;

  > button:nth-child(1) {
    margin-right: 5px;
  }
}
.general-details {
  flex-direction: column;
  width: 100%;
  overflow: visible;
}


</style>